import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rentCycle' })
export class RentCyclePipe implements PipeTransform {
  transform(cycle: any): string {
    if (cycle === 'daily') {
        return `per night`
    } else if (cycle === 'weekly') {
        return 'per week'
    } else if (cycle === 'monthly') {
        return `per month`
    } else if (cycle === 'quarterly') {
        return `per quarter`
    } else if (cycle === 'yearly') {
        return `per year`
    }
    return cycle
  }
}
